import React from 'react'

import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'

const CoverSection = () => (
  <View id="2">
    <Text bold size="small">
      2. INTRODUÇÃO
    </Text>

    <Separator weight={4} />

    <Text>
      Ergonomia é o estudo das interações das pessoas com a tecnologia, a organização e o ambiente, objetivando
      intervenções e projetos que visem melhorar de forma integrada e não dissociada a segurança, o conforto, o
      bem-estar e a eficácia das atividades humanas.
      <br />
      O Engenheiro Inglês Murrel, em 1949, se inspirou na raiz grega Érgon para cunhar o termo ergonomia.
      <br />
      Érgo=trabalho
      <br />
      Nomos= regras
      <br />
      “As regras para se organizar o trabalho”
      <br />
      OIT - Organização Internacional do Trabalho define ergonomia como sendo a "aplicação das ciências biológicas
      conjuntamente com as ciências da engenharia para lograr o ótimo ajustamento do homem ao seu trabalho, e assegurar,
      simultaneamente, eficiência e bem-estar"
      <br />. A International Ergonomics Association (IEA) define ergonomia como "o estudo científico da relação entre o
      homem e seus meios, métodos e espaços de trabalho. Seu objetivo é elaborar, mediante a contribuição de diversas
      disciplinas científicas que a compõem, um corpo de conhecimentos que, dentro de uma perspectiva de aplicação, deve
      resultar em uma melhor adaptação ao homem dos meios tecnológicos e dos ambientes de trabalho e de vida".
      <br />
      Associação Brasileira de Ergonomia (ABERGO) define ergonomia como “o estudo da adaptação do trabalho às
      características fisiológicas e psicológicas do ser humano"
    </Text>

    <Separator weight={8} />
  </View>
)

export default CoverSection
